import React, {useState} from 'react';
import {Box, Center, Image, SimpleGrid, Text, useBreakpointValue,} from '@chakra-ui/react';
import {Link, useNavigate, useSearchParams} from 'react-router-dom';
import {AnimatePresence, motion} from 'framer-motion';

const MotionedSimpleGrid = motion(SimpleGrid);
const MotionedBox = motion(Box);

const PortfolioListGridView = ({companies: options}) => {
    const companies = [...options]
    const count = useBreakpointValue({base: 10, md: 16});

    const [, setState] = useState(null);

    React.useEffect(() => {
        // console.log('GridView 1', window.performance.memory.usedJSHeapSize);
        setState(count);
    }, [count]);

    if (companies?.length < 1) {
        return null
    }

    return (
        <>
            <MotionedSimpleGrid
                width="100%"
                maxW="100%"
                minW="100%"
                mx={0}
                columns={[1, 1, 3, 4, 4]}
                spacingX="10px"
                spacingY="20px"
            >
                <AnimatePresence>
                    {companies?.sort((a, b) => a.company_name.toLowerCase().localeCompare(b.company_name.toLowerCase()))?.map((item, index) => {
                        // console.log('company_item', item);
                        return (
                            <MotionedBox
                                initial={{opacity: 0}}
                                animate={{opacity: 1}}
                                exit={{opacity: 0}}
                                whileHover={{scale: 1.05}}
                                whileTap={{scale: 0.95}}
                                transition={{duration: 0.4}}
                                layout
                                height={'254'}
                                className={'portfolio-item-motionbox'}
                                id={`portfolio-item-${item.slug}`}
                                key={`company-grid-${item.id}`}
                            >
                                <CompanyItem {...item} />
                            </MotionedBox>
                        )
                    })}
                </AnimatePresence>
            </MotionedSimpleGrid>
        </>
    );
};

const CompanyItem = (props) => {
    const [searchParams] = useSearchParams();
    const {company_logo, company_name, sector, slug, company_status, investment_sectors, sector_slug} = props;
    const navigate = useNavigate()
    const activeSector = searchParams.get('sector');
    const showAll = searchParams.get('show');
    const statusFlag = searchParams.get('status');
    const series = searchParams.get('series');
    const hasFilter = showAll || activeSector;
    // console.log('company_props', props)
    /*
        onClick={() => {
                    if (activeSector) {
                        navigate(`/companies/${slug}?sector=${activeSector}`);
                    } else {
                        navigate(`/companies/${slug}`);
                    }
                }}
    */
    return (
        <>
            <Center
                className={'company-' + slug}
                mb={'0.625rem'}
                height={'200'}
                bg={'white'}
                overflow="hidden"
                as={Link}
                to={`/companies/${slug}${(activeSector?`?sector=${activeSector}`:``)}${(showAll?`?show=all`:``)}${statusFlag?`${(hasFilter ? '&' : '?')}status=${statusFlag}`:''}${series?`${(hasFilter ? '&' : '?')}series=${series}`:''}`}
                _hover={{
                    backgroundColor: 'brand.700',
                    '& img': {
                        filter: 'grayscale(1) invert(1)',
                        mixBlendMode: 'screen',
                        objectFit: 'contain',
                        position: 'relative',
                    },
                }}
            >
                <Image src={company_logo} alt={`${company_name}-logo`} maxW="220px" width={`calc(100% - 60px)`}/>
            </Center>
            <Box
                textTransform={'uppercase'}
                fontWeight={'semibold'}
                fontSize={'xs'}
                lineHeight={'4'}
                textAlign={'center'}
                mt={'7px'}
            >
                <Box as={Link}
                     {...Object.assign(
                         {
                             to: sector_slug ? `/companies?sector=${sector_slug}` : '/companies',
                         },
                     )}
                     state={{comingFrom: 'nav'}}>
                    {sector}
                </Box>
                <Text fontWeight={800}>{(company_status != 'Private' ? company_status : ``)}</Text>
            </Box>
        </>
    );
};

export default PortfolioListGridView;
